import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.NON_AUTHENTICATED_AGENCIES_PATH,
	name: routeList.NON_AUTHENTICATED_AGENCIES_NAME,
	component: () => import('@/views/Agencies')
}, {
	path: routeList.AGENCIES_PATH,
	name: routeList.AGENCIES_NAME,
	component: () => import('@/views/Agencies')
}]
